import { ReactElement } from "react";

import TextInputWithCounter from "../components/TextInputWithCounter";
import { LOCALES } from "../constants";
import { GenericObject } from "../types/generic.types";

const UseLocalizedRAInputs = (fields: GenericObject[]): ReactElement<any, any>[] | null => {
  if (!Array.isArray(fields)) return null;

  const resultingElements: ReactElement<any, any>[] = [];

  fields.forEach(({ key, label, validate, multiline, counter, ...props }) => {
    LOCALES.forEach((locale) => {
      resultingElements.push(
        <TextInputWithCounter
          {...props}
          key={`${key}.${locale.key}`}
          source={`${key}.${locale.key}`}
          label={`${label} (${locale.key})`}
          validate={validate[locale.key]}
          counter={counter}
          multiline={multiline}
        />
      );
    });
  });
  return resultingElements;
};

export default UseLocalizedRAInputs;
